var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "imgBox" }, [
          _c(
            "div",
            { staticClass: "imgs66" },
            [
              _c("ResourceUpload", {
                ref: "upload",
                attrs: {
                  showFlodNames: ["个人头像"],
                  flodName: "个人头像",
                  ossRoute: "companyImage",
                  fileLimit: 1,
                  parentId: String(_vm.saveDatas.id),
                  listType: "picture-card",
                },
                model: {
                  value: _vm.picList,
                  callback: function ($$v) {
                    _vm.picList = $$v
                  },
                  expression: "picList",
                },
              }),
            ],
            1
          ),
          _vm.picList.length > 0
            ? _c(
                "p",
                { staticClass: "p1", on: { click: _vm.handlerImgTailorClick } },
                [_vm._v("头像裁剪")]
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "leftBox" },
          [
            _c("p", { staticClass: "p1" }, [_vm._v("基本信息")]),
            _c(
              "el-form",
              {
                ref: "saveDatas",
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.saveDatas,
                  rules: _vm.rules,
                  "label-width": "1.2rem",
                },
              },
              [
                _c("div", { staticClass: "lineBox" }, [
                  _c("div", { staticClass: "lineBoxleft" }, [
                    _c("p", { staticClass: "p2" }, [
                      _c("span", [_vm._v("*")]),
                      _vm._v("绑定手机"),
                    ]),
                    _c("p", [_vm._v(_vm._s(_vm.phone))]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "lineBoxright" },
                    [
                      _c("p", { staticClass: "p3" }, [
                        _c("span", [_vm._v("*")]),
                        _vm._v("昵称"),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "userName" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "1.5rem" },
                            attrs: { size: "small" },
                            model: {
                              value: _vm.saveDatas.userName,
                              callback: function ($$v) {
                                _vm.$set(_vm.saveDatas, "userName", $$v)
                              },
                              expression: "saveDatas.userName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "lineBox" },
                  [
                    _c("p", { staticClass: "p2" }, [
                      _c("span", [_vm._v("*")]),
                      _vm._v("邮箱"),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "email" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "用于接收来自平台的邮件通知，非常重要",
                            size: "small",
                          },
                          model: {
                            value: _vm.saveDatas.email,
                            callback: function ($$v) {
                              _vm.$set(_vm.saveDatas, "email", $$v)
                            },
                            expression: "saveDatas.email",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c("div", { staticClass: "lineBox" }, [
              _c(
                "div",
                { staticClass: "lineBoxleft" },
                [
                  _c("p", { staticClass: "p2" }, [_vm._v("生日")]),
                  _c("el-date-picker", {
                    staticStyle: { width: "1.5rem" },
                    attrs: {
                      "value-format": "yyyy-MM-dd",
                      size: "small",
                      type: "date",
                      placeholder: "选择日期",
                    },
                    model: {
                      value: _vm.saveDatas.birthday,
                      callback: function ($$v) {
                        _vm.$set(_vm.saveDatas, "birthday", $$v)
                      },
                      expression: "saveDatas.birthday",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "lineBoxright" },
                [
                  _c("p", { staticClass: "p3" }, [_vm._v("微信")]),
                  _c("el-input", {
                    staticStyle: { width: "1.5rem" },
                    attrs: { size: "small" },
                    model: {
                      value: _vm.saveDatas.wechat,
                      callback: function ($$v) {
                        _vm.$set(_vm.saveDatas, "wechat", $$v)
                      },
                      expression: "saveDatas.wechat",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "lineBox" }, [
              _c(
                "div",
                { staticClass: "lineBoxleft" },
                [
                  _c("p", { staticClass: "p2" }, [_vm._v("性别")]),
                  _c(
                    "el-select",
                    {
                      staticStyle: {
                        width: "1.3rem",
                        "margin-right": "0.05rem",
                      },
                      attrs: { size: "small", placeholder: "请选择" },
                      model: {
                        value: _vm.saveDatas.sex,
                        callback: function ($$v) {
                          _vm.$set(_vm.saveDatas, "sex", $$v)
                        },
                        expression: "saveDatas.sex",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                  _c("img", {
                    attrs: { src: require("@/assets/png/xinbie.png"), alt: "" },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "lineBoxright" },
                [
                  _c("p", { staticClass: "p3" }, [_vm._v("微博")]),
                  _c("el-input", {
                    staticStyle: { width: "1.5rem" },
                    attrs: { size: "small" },
                    model: {
                      value: _vm.saveDatas.weibo,
                      callback: function ($$v) {
                        _vm.$set(_vm.saveDatas, "weibo", $$v)
                      },
                      expression: "saveDatas.weibo",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "lineBox" }, [
              _c(
                "div",
                { staticClass: "lineBoxleft" },
                [
                  _c("p", { staticClass: "p2" }, [_vm._v("哪一年入行")]),
                  _c("el-date-picker", {
                    staticStyle: { width: "1.2rem", "margin-right": "0.1rem" },
                    attrs: {
                      "value-format": "yyyy",
                      size: "small",
                      type: "year",
                      placeholder: "选择年",
                    },
                    model: {
                      value: _vm.saveDatas.professionDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.saveDatas, "professionDate", $$v)
                      },
                      expression: "saveDatas.professionDate",
                    },
                  }),
                  _c(
                    "span",
                    { staticClass: "p2", staticStyle: { width: "0.6rem" } },
                    [
                      _vm._v(
                        "年 " +
                          _vm._s(_vm.getGzYear(_vm.saveDatas.professionDate)) +
                          " 年"
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "lineBoxright" },
                [
                  _c("span", { staticClass: "p3" }, [_vm._v("职业")]),
                  _c("el-input", {
                    staticStyle: { width: "1.4rem", "margin-right": "0.1rem" },
                    attrs: { size: "small" },
                    model: {
                      value: _vm.saveDatas.career,
                      callback: function ($$v) {
                        _vm.$set(_vm.saveDatas, "career", $$v)
                      },
                      expression: "saveDatas.career",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "lineBox" }, [
              _c(
                "div",
                { staticClass: "lineBoxleft" },
                [
                  _c("p", { staticClass: "p2" }, [_vm._v("走遍世界的脚步")]),
                  _c("el-input", {
                    staticStyle: { width: "0.8rem", "margin-right": "0.1rem" },
                    attrs: { type: "number", size: "small" },
                    model: {
                      value: _vm.saveDatas.countrySize,
                      callback: function ($$v) {
                        _vm.$set(_vm.saveDatas, "countrySize", $$v)
                      },
                      expression: "saveDatas.countrySize",
                    },
                  }),
                  _c("span", { staticClass: "p2" }, [_vm._v("个国家")]),
                  _c("el-input", {
                    staticStyle: { width: "0.8rem", "margin-right": "0.1rem" },
                    attrs: { type: "number", size: "small" },
                    model: {
                      value: _vm.saveDatas.citySize,
                      callback: function ($$v) {
                        _vm.$set(_vm.saveDatas, "citySize", $$v)
                      },
                      expression: "saveDatas.citySize",
                    },
                  }),
                  _c("span", { staticClass: "p2" }, [_vm._v("个城市")]),
                ],
                1
              ),
            ]),
            _vm._m(0),
            _c(
              "div",
              { staticClass: "lineBox" },
              [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    placeholder: "请输入内容",
                    rows: "5",
                    "show-word-limit": "",
                  },
                  model: {
                    value: _vm.saveDatas.customerMessage,
                    callback: function ($$v) {
                      _vm.$set(_vm.saveDatas, "customerMessage", $$v)
                    },
                    expression: "saveDatas.customerMessage",
                  },
                }),
              ],
              1
            ),
            _vm._m(1),
            _c(
              "div",
              {
                staticClass: "lineBox",
                staticStyle: { "margin-bottom": "0.24rem" },
              },
              [
                _c(
                  "div",
                  { staticClass: "imgs66" },
                  [
                    _c("ResourceUpload", {
                      ref: "upload1",
                      attrs: {
                        showFlodNames: ["我的相册"],
                        flodName: "我的相册",
                        ossRoute: "userPicture",
                        fileLimit: 99,
                        parentId: String(_vm.saveDatas.id),
                        listType: "picture-card",
                      },
                      model: {
                        value: _vm.picList1,
                        callback: function ($$v) {
                          _vm.picList1 = $$v
                        },
                        expression: "picList1",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "mainBoxRight" }, [
        _c("div", { staticClass: "mainBoxRightTopBtn" }, [
          _c(
            "div",
            {
              staticClass: "btns",
              staticStyle: { "margin-right": "0.24rem" },
              on: {
                click: function ($event) {
                  return _vm.save("saveDatas")
                },
              },
            },
            [_vm._v(" 保存 ")]
          ),
          _c("div", { staticClass: "btns1" }, [_vm._v(" 返回 ")]),
        ]),
        _c("div", { staticClass: "mainBoxRightBox" }, [
          _c("div", { staticClass: "mainBoxRightBoxTop" }, [
            _c("div", { staticClass: "topLeft" }, [
              _vm.picList.length > 0
                ? _c("img", {
                    staticClass: "imgs",
                    attrs: { src: _vm.picList[0].url },
                  })
                : _c("img", { staticClass: "imgs", attrs: { src: "#" } }),
              _c("p", { staticClass: "p1" }, [
                _vm._v("麦格仕国际旅行社（北京）有限公司"),
              ]),
              _c("p", { staticClass: "p1" }, [
                _vm._v("北京市朝阳区秀水街1号5号楼10层101号"),
              ]),
            ]),
            _c("div", { staticClass: "topRight" }, [
              _c("p", { staticClass: "p1" }, [
                _vm._v(_vm._s(_vm.saveDatas.userName)),
              ]),
              _c("p", { staticClass: "p2" }, [
                _vm._v(" 经验 "),
                _c("span", [
                  _vm._v(_vm._s(_vm.getGzYear(_vm.saveDatas.professionDate))),
                ]),
                _vm._v(" 年 "),
              ]),
              _c("div", { staticClass: "btns1" }, [_vm._v(" 资深定制师 ")]),
              _c("div", { staticClass: "line" }),
              _c("div", [
                _c("p", { staticClass: "p3" }, [
                  _c("img", {
                    staticClass: "imgs",
                    attrs: { src: require("@/assets/png/iponeY.png") },
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.phone))]),
                ]),
                _c("p", { staticClass: "p3" }, [
                  _c("img", {
                    staticClass: "imgs",
                    attrs: { src: require("@/assets/png/wxY.png") },
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.saveDatas.wechat))]),
                ]),
                _c("p", { staticClass: "p3" }, [
                  _c("img", {
                    staticClass: "imgs",
                    attrs: { src: require("@/assets/png/wbY.png") },
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.saveDatas.weibo))]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "footer" }, [
            _c("div", { staticClass: "describe" }, [
              _c("div", { staticClass: "describeLeft" }),
              _c("div", { staticClass: "describeText" }, [
                _vm._v(_vm._s(_vm.saveDatas.customerMessage)),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "footerImg" },
              _vm._l(_vm.picList1, function (item, index) {
                return _c("img", { key: index, attrs: { src: item.url } })
              }),
              0
            ),
            _c("p", { staticClass: "p1" }, [_vm._v("My Footprints")]),
            _c("p", { staticClass: "p1" }, [
              _c("span", [_vm._v(_vm._s(_vm.saveDatas.countrySize))]),
              _vm._v(" 个国家， "),
              _c("span", [_vm._v(_vm._s(_vm.saveDatas.citySize))]),
              _vm._v(" 个城市 "),
            ]),
            _c(
              "div",
              { staticClass: "info" },
              _vm._l(_vm.infoDatas, function (item) {
                return _c("div", { key: item.title, staticClass: "infoBox" }, [
                  _c("p", { staticClass: "p1" }, [_vm._v(_vm._s(item.num))]),
                  _c("p", { staticClass: "p2" }, [_vm._v(_vm._s(item.title))]),
                ])
              }),
              0
            ),
          ]),
        ]),
      ]),
      _c("addressSeePopup", { ref: "addressSeePopup" }),
      _vm.picList.length > 0
        ? _c("ImgTailor", {
            ref: "ImgTailor",
            attrs: { persionImg: _vm.picList[0].url },
            on: { imgUrlClick: _vm.imgUrlClick },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "lineBox" }, [
      _c("div", { staticClass: "lineBoxleft" }, [
        _c("p", { staticClass: "p2" }, [_vm._v("留给客户的话")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "lineBox" }, [
      _c("div", { staticClass: "lineBoxleft" }, [
        _c("p", { staticClass: "p2" }, [_vm._v("我的相册")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }